import _ from 'lodash';
import socketIOClient from 'socket.io-client';
import sailsIOClient from 'sails.io.js';

let io;
if (window.io) {
  io = window.io;
} else {
  io = socketIOClient.sails ? socketIOClient : sailsIOClient(socketIOClient);
  const { sails } = io;
  _.assign(sails, {
    autoConnect: false,
    environment: PRODUCTION ? 'production' : 'development',
    headers: { url: window.location.hostname },
    reconnection: true,
    transports: ['websocket'],
    url: window.location.origin.replace('app', 'api'),
    useCORSRouteToGetCookie: true,
  });
}

export default io;
